<template>
  <div class="editor" :class="writing">
    <h5>{{ title }}</h5>
    <span class="default-text">
      의견을 남겨주세요…
    </span>
    <div class="editor-icon">
     <label :for="uuid" class="photo"></label>
     <input type="file" @change="insertImage(editor, $event)" ref="myFiles" :id="uuid" class="photo-input"
             accept="image/jpg, image/jpeg, image/gif, image/png"/>

      <button @click="editor.chain().focus().toggleBold().run()" class="is-active font-bold">
        bold
      </button>

      <button @click="editor.chain().focus().toggleItalic().run()" class="is-active italic">
        italic
      </button>

      <button @click="editor.chain().focus().toggleUnderline().run()" class="is-active underline">
        underline
      </button>
    </div>

    <!--    <input type="file" id="file"/>-->
    <!--    <label for="file">이미지업로드</label>-->
    <editor-content class="editor__content" :editor="editor"
                    :class="{'reply' : type === 'reply', 'reply2' : type === 'reply2', 'post' : type === 'post' }"
    />
    <p class="error-text" v-if="errorText">{{errorText}}</p>
  </div>
</template>

<script>

import { Editor, EditorContent } from '@tiptap/vue-2'
import { Underline } from '@tiptap/extension-underline'
import { Image } from '@tiptap/extension-image'
import Placeholder from '@tiptap/extension-placeholder'
import CharacterCount from '@tiptap/extension-character-count'
import Link from '@tiptap/extension-link'
import TextAlign from '@tiptap/extension-text-align'
import Text from '@tiptap/extension-text'
import Paragraph from '@tiptap/extension-paragraph'
import Document from '@tiptap/extension-document'
import { Italic } from '@tiptap/extension-italic'
import Bold from '@tiptap/extension-bold'
import HardBreak from '@tiptap/extension-hard-break'
import Dropcursor from '@tiptap/extension-dropcursor'
import { imageUpload } from '@/api/ut'

export default {
  components: {
    EditorContent
  },
  props: [
    'title',
    'value',
    'placeholder',
    'type',
    'limit',
    'writing',
    'active',
    'errorText'
  ],
  data () {
    return {
      editor: null,
      files: null,
      uuid: new Date().getTime()
    }
  },
  watch: {
    active: {
      handler () {
        if (this.active) {
          this.editor.chain().focus()
        }
      }
    },
    value (value) {
      // HTML
      const isSame = this.editor.getHTML() === value
      if (isSame) {
        return
      }
      this.editor.commands.setContent(this.value, false)
    },
    placeholder: {
      handler () {
        this.editor.options.extensions[2].options.placeholder = this.placeholder
        // this.editor.extensions.options.placeholder.emptyNodeText = this.placeholder
        const placeholderNode = document.querySelector('p[data-placeholder]')
        if (placeholderNode) {
          placeholderNode.setAttribute('data-placeholder', this.placeholder)
        }
      }
    }
  },
  mounted () {
    this.editor = new Editor({
      extensions: [
        Underline,
        Image,
        Placeholder.configure({
          placeholder: this.placeholder
        }),
        Link,
        TextAlign,
        Text,
        Paragraph,
        Document,
        Italic,
        HardBreak,
        Bold,
        Dropcursor,
        CharacterCount.configure({
          limit: this.limit
        })
      ],
      autofocus: false,
      content: this.value,
      onUpdate: () => {
        let content = this.editor.getHTML()
        // const json = this.editor.getJSON().content

        let imageCheck = false
        if (content && content.indexOf('<img ') > -1) {
          imageCheck = true
        }
        // HTML

        if (!imageCheck && this.editor.state.doc.textContent.trim().length <= 0) {
          content = null
        }

        // const editor = this.editor

        // if (content && this.type === 'post' && editor && editor.contentComponent && editor.contentComponent.$el && editor.contentComponent.$el.querySelector('.ProseMirror')) {
        //   editor.contentComponent.$el.querySelector('.ProseMirror').style.height = '260px'
        // }

        this.$emit('input', content)
      },
      onBlur: () => {
        this.$emit('editorBlur', true)
      }

      // onFocus: () => {
      //   console.log('111')
      //   const editor = this.editor
      //   if (this.type === 'post' && editor && editor.contentComponent && editor.contentComponent.$el && editor.contentComponent.$el.querySelector('.ProseMirror')) {
      //     editor.contentComponent.$el.querySelector('.ProseMirror').style.height = '90px'
      //   }
      //
      // },
      // onBlur: () => {
      //   console.log('222')
      //   const editor = this.editor
      //   if (this.type === 'post' && editor && editor.contentComponent && editor.contentComponent.$el && editor.contentComponent.$el.querySelector('.ProseMirror')) {
      //     editor.contentComponent.$el.querySelector('.ProseMirror').style.height = '260px'
      //   }
      // }
    })
  },
  beforeDestroy () {
    this.editor.destroy()
  },
  methods: {
    async insertImage (editor, event) {
      const formData = new FormData()
      formData.append('upload', this.$refs.myFiles.files[0])
      const data = await imageUpload(formData)

      if (data && data.success) {
        this.editor.chain().setImage({ src: data.result.url }).run()
        this.editor.chain().focus().setHardBreak()

        setTimeout(function () {
          this.editor.view.dom.scrollTo(0, 1000)
          // this.editor.focus()
          // console.log(this.editor.view.dom)
          // const pElem = document.createElement('p')
          // pElem.innerText = ''
          // this.editor.view.dom.appendChild(pElem)
          // this.editor.view.dom.scrollTo(0, 1000)
          // this.editor.view.dom.click()
          // this.editor.chain().focus()
        }.bind(this), 300)
      } else {
        // const code = result.error.code
        //
        // await openMessage(MAIL_TEXT.FILE_TOO_LENGTH.title, MAIL_TEXT.FILE_TOO_LENGTH.text, 'pwd-reset')
      }
      if (document.querySelector('#file')) {
        document.querySelector('#file').value = ''
      }
    }
  }
}
</script>

<style lang="scss">
.editor {
  position: relative;
  width: 100%;
  height: auto;
  box-sizing: border-box;
  margin-bottom: 65px;

  h5 {
    font-size: 13px;
    font-weight: 500;
    color: #767676;
    margin: 0 0 5px 5px;
  }

  & > .default-text {
    display: none;
  }

  .error-text {
    position: absolute;
    bottom: -20px;
    left: 5px;
    font-size: 12px;
    font-weight: 500;
    color: #e60724;
  }

  .editor-icon {
    display: block;
    position: absolute;
    bottom: 20px;
    left: 20px;

    .photo {
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
      width: 25px;
      height: 25px;
      background: url('../../assets/images/icon/icon-editor-photo.svg') no-repeat center;
      margin-right: 10px;
    }

    .photo-input[type="file"] {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      border: 0;
    }

    .video {
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
      width: 25px;
      height: 25px;
      background: url('../../assets/images/icon/icon-editor-video.svg') no-repeat center;
      margin-right: 10px;
    }

    .video-input[type="file"] {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      border: 0;
    }

    .link {
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
      width: 25px;
      height: 25px;
      background: url('../../assets/images/icon/icon-editor-file.svg') no-repeat center;
      text-indent: -9999px;
      margin-right: 10px;
    }

    .font-bold {
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
      width: 25px;
      height: 25px;
      background: url('../../assets/images/icon/icon-editor-bold.svg') no-repeat center;
      text-indent: -9999px;
      margin-right: 10px;
    }

    .italic {
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
      width: 25px;
      height: 25px;
      background: url('../../assets/images/icon/icon-editor-italic.svg') no-repeat center;
      text-indent: -9999px;
      margin-right: 10px;
    }

    .underline {
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
      width: 25px;
      height: 25px;
      background: url('../../assets/images/icon/icon-editor-underline.svg') no-repeat center;
      text-indent: -9999px;
    }

  }

  .editor__content {
    display: block;
    max-width: 100%;
    height: 450px;
    // margin: 10px 20px 65px;
    padding: 17px 20px;
    font-size: 16px;
    color: #222;
    line-height: 1.63;
    border-radius: 6px;
    border: solid 1px #bbb;
    box-sizing: border-box;

    .ProseMirror {
      outline: none;
      height: 370px;
      overflow-y: auto;
      font-size: 14px;
      line-height: 1.57;
      color: #2f2f2f;
      box-sizing: border-box;
      padding-right: 10px;

      > * + * {
        margin-top: 0.75em;
      }

      & > p {
        font-size: 14px;
        line-height: 1.57;
        color: #2f2f2f;
      }

      img {
        max-width: 100%;
        height: auto;

        &.ProseMirror-selectednode {
          outline: 3px solid #68CEF8;
        }
      }
    }

    .ProseMirror p.is-editor-empty:first-child::before {
      content: attr(data-placeholder);
      float: left;
      pointer-events: none;
      height: 0;
      font-size: 14px;
      color: #bbb;
    }
  }
}
</style>
